<template>
  <el-card>
    <div class="ch-user">
      <div class="avatar">
        <el-avatar :size="80" :src="$images.default_avatar_1"></el-avatar>
      </div>
      <div class="nickname">Hi欢迎来到金沫旅游</div>
    </div>

    <div class="button-box">
      <el-button type="primary" class="button" @click="onLogin">登陆</el-button>
    </div>
    <div class="button-box">
      <el-button type="primary" class="button" @click="onRegister" plain>注册</el-button>
    </div>
  </el-card>
</template>

<script>
export default {
  methods:{
    /**
     * 注册
     */
    onRegister(){
      sessionStorage.setItem('loginWay', 1)
      this.$router.push('/register')
      // this.$router.push('/choice')
    },
    /**
     * 登录
     */
    onLogin(){
      sessionStorage.setItem('loginWay', 0)
      this.$router.push("/login")
    }
  }
}
</script>

<style lang="less" scoped>
.ch-user {
  text-align: center;
  margin-bottom: 20px;
}
.nickname {
  font-size: 14px;
  color: #333333;
  margin-top: 10px;
}

.button-box + .button-box {
  margin-top: 15px;
}
.button {
  display: block;
  width: 100%;
}
</style>